import { useContext } from "react";
import { ClassifiedContext } from "./provider";
// Classified can be 'null' in case of Error
// In case of Error, we still want to display the CDP Error page
export const useClassified = () => {
    const context = useContext(ClassifiedContext);
    if (context === undefined) {
        throw new Error("useClassified must be used within a ClassifiedContext provider");
    }
    return context;
};
export const useClassifiedId = () => { var _a; return (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.id; };
export const useTracking = () => { var _a; return (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking; };
export const useFarbweltConfig = () => { var _a; return (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.farbwelt; };
export const useDefaultBackToSearch = () => { var _a; return (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.defaultBackToSearch; };
// Sections
export const useSections = () => { var _a; return (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.sections; };
export const useHardFacts = () => { var _a; return (_a = useSections()) === null || _a === void 0 ? void 0 : _a.hardFacts; };
export const usePriceComparison = () => { var _a, _b; return (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.priceComparison) !== null && _b !== void 0 ? _b : {}; };
export const useHardFactsTitle = () => {
    var _a, _b, _c;
    return ({
        title: ((_a = useHardFacts()) === null || _a === void 0 ? void 0 : _a.title) || "",
        titleAdditions: (_c = (_b = useHardFacts()) === null || _b === void 0 ? void 0 : _b.titleAdditions) !== null && _c !== void 0 ? _c : [],
    });
};
export const useHeadInfo = () => { var _a, _b; return (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.seo) === null || _b === void 0 ? void 0 : _b.headInfo; };
export const useLegacyId = () => { var _a, _b; return (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.legacyId; };
export const useUnits = () => { var _a; return (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.units; };
export const useIsRentClassified = () => { var _a, _b; return ((_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.rawData) === null || _b === void 0 ? void 0 : _b.distributionType) === "RENT"; };
